import { readStorageFlag, writeStorageFlag } from '@shared/lib'
import {
  OlympiadParticipantStatus,
  type ParticipantOlympiad,
  type ParticipantRegistration,
} from './types'

/** Регистрация, о которой участнику стоит сказать один раз: отмена или
 *  дисквалификация. */
export function noticeRegistration(olympiad: ParticipantOlympiad): ParticipantRegistration | null {
  const registration = olympiad.participant_registration
  if (!registration) return null
  const { status } = registration
  const isNotable =
    status === OlympiadParticipantStatus.disqualified ||
    (status === OlympiadParticipantStatus.cancelled && !olympiad.registered)
  return isNotable ? registration : null
}

const NOTICE_KEY_PREFIX = 'olympiad-registration-notice'

/** Ключ показа: новая отмена после повторной записи — другой `registration.id`
 *  или другой статус, и окно покажется снова. */
export function noticeStorageKey(registration: Pick<ParticipantRegistration, 'id' | 'status'>) {
  return `${NOTICE_KEY_PREFIX}:${registration.id}:${registration.status}`
}

/** Окно уже показывали? Без хранилища (приватное окно, запрет) оно просто
 *  показывается, а не падает. */
export function hasSeenNotice(registration: Pick<ParticipantRegistration, 'id' | 'status'>) {
  return readStorageFlag(noticeStorageKey(registration))
}

export function markNoticeSeen(registration: Pick<ParticipantRegistration, 'id' | 'status'>) {
  writeStorageFlag(noticeStorageKey(registration))
}
